/**
 * Get proper asset file path from the plugins assets folder.
 */
export const getAsset = (assetFileName) => {
	// eslint-disable-next-line no-undef
	return hbImagesFolderPath + assetFileName;
};
